import { createFileRoute, Outlet } from "@tanstack/react-router"
import { useEffect } from "react"

/**
 * People management layout route
 */
export const Route = createFileRoute("/_authenticated/$orgSlug/people")({
  loader: ({ params }) => {
    return {
      title: "Pessoas",
      path: `/${params.orgSlug}/people`,
    }
  },
  component: PeopleLayout,
})

function PeopleLayout() {
  const path = Route.useLoaderData()
  const { breadcrumbs } = Route.useRouteContext()

  useEffect(() => {
    breadcrumbs.setCurrentPath(path)
  }, [breadcrumbs, path])

  return <Outlet />
}
